import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import FormMensaisPort from "../../../Portfolio_v1/MetasPortfolio/FormMensaisPort";

export default class Form extends Component {

    constructor(props) {
        super(props);
        
        this.state = {
            aplicationName: "Form Meta"
        }

    }

    async componentDidUpdate(prevProps, prevState) {
        if(prevState.metas !== this.state.metas) {
            //await this.consultaMetas();
        }
    }

    async componentDidMount() {
        //await this.consultaMetas();
    }

    render() {
        let { linhas, categorias, cr, produtos, produtoSelecionado, linhaSelecionada } = this.props;
        let isDisabled = linhaSelecionada === "Metrologia" ? false : true;
        return (
            <Fragment>
                <div className="row pr-3 pl-3">
                        <div className="col-md-12 ml-auto mr-auto">
                            <div className="card card-user">
                                <div className="card-header">
                                    <h5 className="card-title">Serviços STI - Metas por Portfólio</h5>
                                    {/*
                                    <Link to={location => (
                                        { 
                                            ...location, 
                                            pathname: `./${this.props.unidade}/formcadastro`, 
                                            anterior: window.location.pathname || "/unidade", 
                                            unidade: this.props.unidade 
                                        }
                                        )}>
                                        <button className="btn" style={{float: "right"}}>Novo Produto</button>
                                    </Link>
                                    */}
                                    {/* <Link to={location => (
                                        { 
                                            ...location, 
                                            pathname: `./${this.props.unidade}/despesas`, 
                                            anterior: window.location.pathname || "/unidade", 
                                            unidade: this.props.unidade 
                                        }
                                        )}>
                                        <button className="btn" style={{float: "right"}}>Despesas</button>
                                    </Link> */}
                                </div>
                                <div className="card-body">
                                    <form onSubmit={this.props.onSubmit} className="gap" onChange={this.props.onChange}>

                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor="linhaAtuacao">Linha de Atuação:</label>
                                                    <select name="linhaAtuacao" id="linhaAtuacao" onChange={this.props.onChangeLinha} className="form-control" required>
                                                        <option hidden>Escolha uma Linha de Atuação</option>
                                                        {linhas.map((linha) => <option key={linha} value={linha}>{linha}</option>)}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-8">
                                                <div className="form-group">
                                                    <label htmlFor="categoria">Categorias:</label>
                                                    <select name="categoria" id="categoria" onChange={this.props.onChangeCategoria} className="form-control" required>
                                                        <option hidden>Escolha uma Categoria</option>
                                                        {categorias.map((categoria) => <option key={categoria.categoria} value={categoria.categoria}>{categoria.categoria}</option>)}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label htmlFor="cr">CR</label>
                                                    <input type="text" className="form-control" placeholder="cr" id="cr" name="cr" defaultValue={cr} disabled />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor="produtoNacional">Produto:</label>
                                                    <select name="produtoNacional" onChange={this.props.onChangeProduto} className="form-control" required>
                                                        <option hidden>Escolha uma Produto</option>
                                                        {produtos && produtos.map((produto) => <option key={produto._id} value={produto.Produto}>{produto.Produto}</option>)}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-12">
                                                {produtoSelecionado 
                                                    && 
                                                    <span>
                                                        <span className="btn btn-link btn-danger remove" onClick={() => this.props.exibeFichaSweetAlert(produtoSelecionado)}>
                                                            <i className="fa fa-times"></i>Detalhes
                                                        </span>
                                                    </span>
                                                }
                                            </div>
                                        </div>
                                        
                                        {/*
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor="setor">Setor</label>
                                                    <input type="text" className="form-control" placeholder="setor" id="setor" name="setor" />
                                                </div>
                                            </div>
                                        </div>
                                        */}

                                        <div className="row">

                                            <div className="col-md-2">
                                                <div className="form-group">
                                                    <label htmlFor="metaEmpresasAtendidas">Meta de Empresas Atendidas</label>
                                                    <input type="value" className="form-control" placeholder="0" id="metaEmpresasAtendidas" name="metaEmpresasAtendidas" />
                                                </div>
                                            </div>

                                            <div className="col-md-2">
                                                <div className="form-group">
                                                    <label htmlFor="metaAtendimentos">Meta de Atendimento</label>
                                                    <input type="value" className="form-control" placeholder="0" id="metaAtendimentos" name="metaAtendimentos" required />
                                                </div>
                                            </div>

                                            <div className="col-md-2">
                                                <div className="form-group">
                                                    <label htmlFor="mediaHH">Média de H.H por atendimento</label>
                                                    <input type="number" step="0.01" className="form-control" placeholder="0" id="mediaHH" name="mediaHH" disabled={!isDisabled} required />
                                                </div>
                                            </div>

                                            <div className="col-md-2">
                                                <div className="form-group">
                                                    <label htmlFor="totalHH">H.H Total</label>
                                                    <input type="value" className="form-control" placeholder="0" id="totalHH" name="totalHH" disabled />
                                                </div>
                                            </div>

                                            <div className="col-md-2">
                                                <div className="form-group">
                                                    <label htmlFor="totalEnsaiosCalibracoes">Total Ensaios / Calibrações</label>
                                                    <input type="value" className="form-control" placeholder="0" id="totalEnsaiosCalibracoes" name="totalEnsaiosCalibracoes" disabled={isDisabled} />
                                                </div>
                                            </div>

                                            <div className="col-md-2">
                                                <div className="form-group">
                                                    <label htmlFor="totalLaudosRelatorios">Total Laudos / Relatórios</label>
                                                    <input type="value" className="form-control" placeholder="0" id="totalLaudosRelatorios" name="totalLaudosRelatorios" disabled={isDisabled} />
                                                </div>
                                            </div>

                                            <input type="hidden" step="0.01" className="form-control" placeholder="0,00" id="valorHora" name="valorHora" required />
                                            <input type="hidden" className="form-control" placeholder="0,00" id="receitaPrevista" name="receitaPrevista" disabled />

                                        </div>

                                        {/*
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor="colaborador">Colaborador/Consultor</label>
                                                    <input type="text" className="form-control" placeholder="nome do colaborador/consultor" id="colaborador" name="colaborador"  />
                                                </div>
                                            </div>
                                        </div>
                                        */}

                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label>Informações adicionais</label>
                                                    <textarea className="form-control textarea" name="comentario" placeholder={"Escreva algo..."}></textarea>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        {/*
                                        <div className="row">
                                            <div className="col-md-12">
                                                <Link to={location => ({ ...location, pathname: `${this.props.unidade}/novoform` })} >
                                                    <button className="btn btn-secondary">Metas Mensais</button>
                                                </Link>
                                            </div>
                                        </div>
                                        */}

                                        <div className="row">
                                            <div className="col-md-12">
                                                <FormMensaisPort unidade={"unidade"} {...this.state} linhaSelecionada={linhaSelecionada} onSubmit={this.onSubmit} />
                                            </div>
                                        </div>
                                        
                                        <div className="row">
                                            <div className="update ml-auto mr-auto">
                                                <button type="submit" className="btn btn-primary btn-round">Cadastrar</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>

            </Fragment>
        )
    }

}